import { NumberInput } from './number.mjs';
import { registerCustomElement, create, isAttribute } from '../utils.mjs';
import './range.scss';

export class RangeInput extends NumberInput {
	async build(instructions, value, metadata = false) {
		super.build(instructions, value, metadata);

		const numberInput =
			this.querySelector('imt-coder') == null ? this.querySelector('.form-control') : this.querySelector('imt-coder');

		numberInput.style.display = 'none';

		if (value == undefined) {
			this.value =
				instructions.max < instructions.min
					? instructions.min
					: Math.floor(instructions.min + (instructions.max - instructions.min) / 2);
		} else {
			this.value = value;
		}

		const formGroup = create('div.form-group');
		const input = create('input.form-control-range');
		const label = create('div.range-label');

		const label1 = create('p');
		const label2 = create('p');

		label1.innerHTML = instructions.min;
		label2.innerHTML = instructions.max;

		label.appendChild(label1);
		label.appendChild(label2);

		const output = create('span.range-output');

		output.appendChild(create('span.value'));

		input.setAttribute('type', 'range');
		input.setAttribute('name', 'rangeBar');
		input.setAttribute('min', instructions.min);
		input.setAttribute('max', instructions.max);
		input.setAttribute('step', instructions.step);
		input.setAttribute('value', this.value);

		this.setPositionOfValue(instructions, output, this.value, numberInput);

		input.addEventListener('input', (event) => {
			this.setPositionOfValue(instructions, output, event.target.value, numberInput);
			this.value = event.target.value;
		});

		if (instructions.disabled == true || instructions.readonly) {
			input.disabled = true;
		}

		formGroup.appendChild(label);
		formGroup.appendChild(input);
		formGroup.appendChild(output);

		this.appendChild(formGroup);
	}

	setPositionOfValue(instructions, value, number, numberInput) {
		numberInput.innerHTML = number;
		const min = instructions.min;
		const max = instructions.max;
		const newValue = Number(((number - min) * 100) / (max - min));
		const valueSpan = value?.querySelector('span.value');
		let newPosition = 10 - newValue * 0.2;

		if (!valueSpan) {
			return;
		}

		valueSpan.innerText = number;
		if (
			(newValue / 100) * this.offsetWidth + value.children[0].offsetWidth / 2 - 10 > this.offsetWidth ||
			Number(number) === max
		) {
			const left = this.offsetWidth - value.children[0].offsetWidth * 0.5 + 'px';

			value.setAttribute('style', `left: ${left}`);
		} else {
			if (Number(number) === min) {
				if (min < 10) {
					newPosition -= 5;
				}

				if (min > 9) {
					value.style.left = value.children[0].offsetWidth / 2 + 'px';
					return;
				}

				value.style.left = `calc(${newValue}% + (${newPosition}px))`;
			} else {
				value.style.left = `calc(${newValue}% + (${newPosition}px))`;
			}
		}
	}

	get hasModeSwitch() {
		return this.mappable || isAttribute(this, 'mappable');
	}
}

registerCustomElement('imt-input-range', RangeInput);
